// Point to local, test or live site Wordpress REST API.

// export const url = 'http://friends-for-brands.local';
// export const url = 'http://dev-ffb.ffbvps.nl';
export const url = 'https://friendsagency.com';



// WEBPACK FOOTER //
// ./src/config.js